export class LoginModel {
  email: string;
  password: string;
}

export class VerifyTwoFactorModel {
  email: string;
  code: string;
}

export class VerifyCompanyCodeModel {
  userId: string | null = null;
  companyId: any;
  code: string;
}

export class ResetPasswordModel {
  email: string;
  password: string;
  code: string;
}

export class ForgotPasswordModel {
  email: string;
}

export class LoginResponseModel {
  Response: any;
  SelectedCompany: any;
}
